export const routes = {
    DEFAULT: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    TENANTS: '/tenants',
    NOTIFICATIONS: '/notifications',
    SETTINGS: '/profile',
    CHECKLIST_NONFB: '/checklist-nonfb',
    CHECKLIST_FB:'/checklist-fb',
    CHECKLIST_COVID:'/checklist-covid',
    TEMPLATES: '/checklist-templates',
    PHOTOS:'/checklist-photos',
    REPORT: '/report',
    CREATE_USER: '/createuser',
    AUDIT: '/audit'
};

export const TOKEN = 'jwt';
export const DATE_FORMAT = 'DD MMM YYYY';
export const EXT_INITIAL = 'No Extensions';
export const AUDIT_ACTIONS = {
    SUBMIT_AUDIT: 'submit',
    DRAFT_AUDIT: 'draft',
    UNRECTIFIED_AUDIT: 'unrectified',
    RECTIFIED_AUDIT: 'rectified',
    AUDITED: 'audited'
}

export const RESPONSIVE_GUTTER = { xs: 8, sm: 16, md: 24, lg: 32 };
